import React from 'react';

const Contact: React.FC = () => {
  const email = 'contact@zwiftlabs.com';
  const phone = '+353899831792';

  return (
    <section id="contact" className="section-padding bg-white">
      <div className="container-max">
        <div className="max-w-2xl mb-10">
          <h2 className="text-4xl md:text-5xl font-semibold text-black mb-4 leading-[1.05] tracking-[-0.02em]">
            Contact us
          </h2>
          <p className="text-lg text-neutral-600">
            Reach out by email or phone, we'll get back to you soon.
          </p>
        </div>

        <div className="flex flex-col sm:flex-row gap-4">
          <a
            href={`mailto:${email}`}
            className="flex items-center gap-3 bg-white rounded-2xl px-6 py-5 border border-neutral-200 hover:border-neutral-900 transition-colors"
          >
            <svg className="w-5 h-5 text-neutral-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.8} d="M3 8l7.89 4.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" />
            </svg>
            <span className="text-neutral-800 font-medium">{email}</span>
          </a>

          <a
            href={`tel:${phone}`}
            className="flex items-center gap-3 bg-white rounded-2xl px-6 py-5 border border-neutral-200 hover:border-neutral-900 transition-colors"
          >
            <svg className="w-5 h-5 text-neutral-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.8} d="M3 5a2 2 0 012-2h3.28a1 1 0 01.948.684l1.498 4.493a1 1 0 01-.502 1.21l-2.257 1.13a11.042 11.042 0 005.516 5.516l1.13-2.257a1 1 0 011.21-.502l4.493 1.498a1 1 0 01.684.949V19a2 2 0 01-2 2h-1C9.716 21 3 14.284 3 6V5z" />
            </svg>
            <span className="text-neutral-800 font-medium">{phone}</span>
          </a>
        </div>
      </div>
    </section>
  );
};

export default Contact;
